<template>
    <v-list-item-group>
      <p>Routers:</p>
      <v-list-item
        v-for="router in routersLibres"
        :key="router.id"
        :value="router.id"
        @click="onRouterSelected(router)"
  
      >
        <v-list-item-content>
          <v-list-item-title>{{ router.num_router }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </template>
  
  <script>
  export default {
    props: {
      routersLibres: {
        type: Array,
        required: true
      },
      
    },
    methods: {
      onRouterSelected(router) {
        // Emitir un evento al componente padre
        this.$emit('routerSelected', router)
      }
    }
  }
  </script>